import React, { useEffect, useState, useContext, Fragment, useMemo } from 'react';
import Layout from 'components/sales/layout/layout';
import { toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import FormSection from 'components/sales/formSection/formSectionNew';
import DropDownInput from 'components/sales/Input/dropDownInput/dropDownInput';
import TableSection from 'components/sales/tableSection/tableSection';
import ListFilters from 'components/sales/ListFilters/ListFilters';
import { AppliedFiltersBar } from 'components/UI';
import {
  INSPECTION_REQUESTS_FILTER_KEY,
  INITIAL_INSPECTION_REQUESTS_FILTERS,
} from 'components/sales/ListFilters/InspectionRequestsFilter';
import Images from 'assets/images/imageData';
import localization from 'assets/localization/localization';
import { Button } from 'react-bootstrap';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import ModalPop from 'components/sales/modal/modal';

const getStoredInspectionFilters = () => {
  try {
    const stored = localStorage.getItem(INSPECTION_REQUESTS_FILTER_KEY);
    if (stored) {
      const parsed = JSON.parse(stored);
      return {
        ...INITIAL_INSPECTION_REQUESTS_FILTERS,
        ...parsed,
      };
    }
  } catch (e) {
    // ignore invalid stored filter payload
  }
  return INITIAL_INSPECTION_REQUESTS_FILTERS;
};

const InspectionRequests = ({
  siteInspectionList,
  viewAssigneeData,
  viewSiteInspectionForms,
  listSiteInspectionManagers,
  changeSiteInspectionManager,
}) => {
  const { baseUrl } = useContext(BaseUrl);
  const [isLoading, setIsLoading] = useState(false);
  const [listData, setListData] = useState();
  const [isModal, setIsModal] = useState(false);
  const [isManagerModal, setIsManagerModal] = useState(false);
  const [pageCount, setPageCount] = useState(0);
  const [filterData, setFilterData] = useState(INITIAL_INSPECTION_REQUESTS_FILTERS);
  const [showFilter, setShowFilter] = useState(false);
  const [managers, setManagers] = useState([]);
  const roleId = localStorage.getItem('fusion-role');
  const input = {
    request_id : 0,
    user_id : 0
  }
  const [formData, setData] = useState(input);
  const [managerForm, setManagerForm] = useState(input);
  const [requestId, setRequestId] = useState(0);

  const headers = [
    'Request Id',
    'Site Name',
    'Site Address',
    'Created By',
    'Created On',
    'Status',
    'Engineer Assigned',
    'Reporting Manager',
    'Action'
  ];

  const filterToggle = () => {
    setShowFilter(!showFilter);
  };

  const applyFilter = async (nextFilterData) => {
    localStorage.setItem(
      INSPECTION_REQUESTS_FILTER_KEY,
      JSON.stringify(nextFilterData)
    );
    setIsLoading(true);
    setFilterData(nextFilterData);
    await viewSiteInspectionForms(nextFilterData, 1);
    setIsLoading(false);
    filterToggle();
  };

  const removeFilter = async () => {
    localStorage.removeItem(INSPECTION_REQUESTS_FILTER_KEY);
    setIsLoading(true);
    setFilterData(INITIAL_INSPECTION_REQUESTS_FILTERS);
    await viewSiteInspectionForms(INITIAL_INSPECTION_REQUESTS_FILTERS, 1);
    setIsLoading(false);
  };

  const appliedFilterLabels = useMemo(() => {
    const labels = [];
    const siteName = filterData?.site_name?.trim();
    const assignedTo = filterData?.assigned_to?.trim();
    const approvedBy = filterData?.approved_by?.trim();

    if (siteName) labels.push(`Site Name: ${siteName}`);
    if (assignedTo) labels.push(`Engineer Assigned: ${assignedTo}`);
    if (approvedBy) labels.push(`Reporting Manager: ${approvedBy}`);

    return labels;
  }, [filterData]);

  useEffect(() => {
    (async () => {
      const storedFilters = getStoredInspectionFilters();
      setFilterData(storedFilters);
      setIsLoading(true);
      await viewSiteInspectionForms(storedFilters, 1);
      if (roleId == 16) {
        const heads = await listSiteInspectionManagers();
        setManagers(heads || []);
      }
      setIsLoading(false);
    })();
  }, []);

  const onPageChange = async (val) => {
    setIsLoading(true);
    await viewSiteInspectionForms(filterData, val.selected + 1);
    setIsLoading(false);
  };
  
  useEffect(() => {
    const tableData = [
        'request_id',
        'site_name',
        'site_address',
        'created_by',
        'created_on',
        'status',
        'assigned_to',
        'approved_by',
        'Action'
      ];
      if (siteInspectionList?.data) {
        const data = siteInspectionList.data.map((element) =>
            Object.assign(
                {},
                ...tableData.map((key) => (
                  (key === 'date_of_purchase')?
                  {[key]: element[key]} : (key==='invoice_copy_path')?
                  {[key]:<a href={element[key]}>View Invoice</a>} : (key === 'status')?
                  (element[key] == 1)?{[key]:<span style={{color:"green"}}>Open</span>}:(element[key] == 2)?{[key]:<span style={{color:"orange"}}>Engineer Assigned</span>}:(element[key] == 3)?{[key]:<span style={{color:"orange"}}>Approval Pending</span>}:{[key]:<span style={{color:"red"}}>Closed</span>}: 
                  {[key]: element[key]}           
                  )
                ),
                {
                  Action: [
                    (element.status == 1 || element.status == 2) && roleId!=9 ?
                    {
                      name: 'Assign Engineer',
                      link: `${element.request_id}`,
                    } 
                    :
                    roleId == 10 && element.status == 4 &&
                    {
                      name: 'Send Mail',
                      link: `${baseUrl}/inspection-form-mail/${element.request_id}`,
                    },
                    roleId == 16 && {
                      name: 'Change Responsible Manager',
                      link: `${element.request_id}`,
                    },
                    element.status > 1 && {
                      name: 'Engineer Inspection Form',
                      link: `${baseUrl}/inspection-form/${element.request_id}`,
                    },
                    {
                      name: 'Sale Inspection Form',
                      link: `${baseUrl}/inspection-created/${element.request_id}`,
                    },
                  ].filter(Boolean)
                }
            )
        );  
        setListData(data);
        const perPage = siteInspectionList?.per_page || 15;
        const total = siteInspectionList?.total || 0;
        setPageCount(Math.ceil(total / perPage));
    }
  }, [siteInspectionList, baseUrl, roleId]);

  const handleSubmit = () => {
    if (formData.request_id == 0 || formData.user_id == 0) {
      toast.error('Please fill all inputs!');
      return;
    } else {
      (async () => {
        setIsLoading(true);
        const res = await viewAssigneeData(formData);
        await viewSiteInspectionForms(filterData, 1);
        setData(input);
        setIsLoading(false);
        if (res) {
          setIsModal(false);
        } else {
          toast.error('Some error occurred. Please try again later.');
          return;
        }
      })();
    }
  }

  const handleManagerSubmit = () => {
    if (managerForm.request_id == 0 || managerForm.user_id == 0) {
      toast.error('Please select a responsible manager!');
      return;
    }
    (async () => {
      setIsLoading(true);
      const res = await changeSiteInspectionManager({
        request_id: managerForm.request_id,
        user_id: managerForm.user_id,
      });
      await viewSiteInspectionForms(filterData, 1);
      setManagerForm(input);
      setIsLoading(false);
      if (res) {
        setIsManagerModal(false);
        toast.success('Responsible manager updated.');
      } else {
        toast.error('Some error occurred. Please try again later.');
      }
    })();
  }

  const headerBtns = () => {
    return (
      <Fragment>
        <Button
          onClick={filterToggle}
          className="filter-hamburger btn btn-transparent"
        >
          <img src={Images?.Filter} alt="" />
          {localization.showFilters}
        </Button>
      </Fragment>
    );
  };

  return (
    <Layout
      title='Site Inspection Requests'
      Buttons={headerBtns}
      isLoading={isLoading}
    >
      <AppliedFiltersBar
        items={appliedFilterLabels}
        onClear={removeFilter}
        clearButtonLabel="Remove filter"
        clearButtonDisabled={isLoading}
      />
      <div div className="cbox">
          <div className="card-body">
            <div className="table-body">
              <div className="d-flex">
                <div className="col-12">
                <TableSection
                    data={listData}
                    isId={false}
                    headers={headers}
                    pageCount={pageCount}
                    srNo={siteInspectionList?.from}
                    onPageChange={onPageChange}
                    assignEngineerPopup={setIsModal}
                    changeResponsibleManagerPopup={setIsManagerModal}
                    setUnclaimedId={setRequestId}
                />
                </div>
              </div>
           </div>
          </div>
          </div>

        <ListFilters
          showFilter={showFilter}
          filterToggle={filterToggle}
          applyFilter={(val) => applyFilter(val)}
          inspectionRequestsFilter
          listFilterData={{ appliedFilterValues: filterData }}
        />
        

        <ModalPop
          title="Assign Engineer"
          show={isModal}
          handleModalHide={()=>setIsModal(false)}
        >
        <div div className="cbox">
            <div className="card-body">
                <div className="table-body">
                    <div className="d-flex">
                        <div className="col-12">
                            <FormSection title='Site Inspection Request Form'>
                                <DropDownInput
                                    label='Assign Engineer'
                                    data={siteInspectionList?.assignee_ids}
                                    required
                                    isStarRequired={true}
                                    errorMsg='Assign Engineer'
                                    getIdValue={(val) => setData({...formData,request_id:parseInt(requestId), user_id:val.id})}
                                />
                                <button disabled={false} type="submit" onClick={handleSubmit} className="btn btn-primary">
                                    Assign
                                    <img src="../images/arrow-right.png" alt="" />
                                </button>
                            </FormSection>
                            
                        </div>
                    </div>
                </div>
            </div>
        </div>
            
        </ModalPop>

        <ModalPop
          title="Change Responsible Manager"
          show={isManagerModal}
          handleModalHide={() => {
            setIsManagerModal(false);
            setManagerForm(input);
          }}
        >
          <div className="cbox">
            <div className="card-body">
              <div className="table-body">
                <div className="d-flex">
                  <div className="col-12">
                    <FormSection title="Responsible Manager">
                      <DropDownInput
                        label="Maintenance Head"
                        data={managers}
                        required
                        isStarRequired={true}
                        errorMsg="Responsible Manager"
                        getIdValue={(val) =>
                          setManagerForm({
                            request_id: parseInt(requestId, 10),
                            user_id: val.id,
                          })
                        }
                      />
                      <button
                        type="submit"
                        onClick={handleManagerSubmit}
                        className="btn btn-primary"
                      >
                        Update
                        <img src="../images/arrow-right.png" alt="" />
                      </button>
                    </FormSection>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ModalPop>
    </Layout>
  );
};

export default InspectionRequests;
